var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"db-block clearBoth"},_vm._l((_vm.data.vertical),function(innerList,index){return _c('g-switch-list2',{key:'iL' + index,staticClass:"switch-wrap",attrs:{"list":innerList.list,"title":innerList.title,"chip":_vm.chip,"verticalType":2}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34029eb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageComponents/pk10/dh1-10.vue
// module id = null
// module chunks = 